export default __webpack_public_path__ + "static/media/7B2_P1979-202-241.3c1242eb.png";